import { useSyncExternalStore } from 'react';

import { DARK_SCHEME_QUERY } from './theme-preference.js';

/**
 * Subscribe to the operating system's colour scheme.
 *
 * `useSyncExternalStore` rather than `useState` plus an effect, because the media
 * query is external state: reading it in an effect would render one frame with a
 * stale value.
 *
 * @param {(onChange: () => void) => void} onStoreChange
 * @returns {() => void} unsubscribe
 */
function subscribe(onStoreChange) {
  const query = globalThis.matchMedia?.(DARK_SCHEME_QUERY);
  if (!query) return () => {};
  query.addEventListener('change', onStoreChange);
  return () => query.removeEventListener('change', onStoreChange);
}

function getSnapshot() {
  return globalThis.matchMedia?.(DARK_SCHEME_QUERY).matches ?? false;
}

/**
 * Whether the device is set to dark mode.
 *
 * Returns false where `matchMedia` is unavailable, which is the correct default:
 * light is the product's base palette.
 *
 * @returns {boolean}
 */
export function useSystemColorScheme() {
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}
